export default __webpack_public_path__ + "static/media/home-freelancer-img-03.35c983b4.jpg";